exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\nsvg[data-v-c39f1c7a] {\n  pointer-events: none;\n\n  position: fixed;\n  right: 0;\n}\nsvg polygon[data-v-c39f1c7a],\nsvg rect[data-v-c39f1c7a] {\n  pointer-events: auto;\n}\n", ""]);

